"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataTablesDefaults;
(function (DataTablesDefaults) {
    DataTablesDefaults.dom = '<"dataTables_header row" <"toolbar col-6" B><"search col-6" f>>rt<"dataTables_footer row" <"col-4" l> <"col-4 text-center" i> <"col-4" p>>';
    DataTablesDefaults.buttons = [];
    DataTablesDefaults.scrollY = '50vh';
    DataTablesDefaults.scrollX = true;
    DataTablesDefaults.scrollCollapse = true;
    DataTablesDefaults.pageLength = 50;
    DataTablesDefaults.language = {
        search: "",
        searchPlaceholder: "Search",
        infoFiltered: '',
        infoPostFix: '',
        processing: '<div class="mb-3 font-weight-bold">LOADING DATA</div><div><i class="fa-solid fa-loader fa-fade text-primary fa-4x"></i></div>'
    };
})(DataTablesDefaults || (DataTablesDefaults = {}));
var DataTablesRenderers;
(function (DataTablesRenderers) {
    DataTablesRenderers.videos = function (data, type, row, meta) {
        if (type === 'display') {
            var url = typeof row.edit !== 'undefined' && row.edit ? row.edit : '';
            if (meta.settings.aoColumns.length > meta.col) {
                var pieces = meta.settings.aoColumns[meta.col].mData.split('.');
                var key = pieces[0];
                if (pieces.length > 1 && typeof row[key] !== 'undefined' && row[key] !== null && typeof row[key].edit !== 'undefined') {
                    if (row[key].edit) {
                        url = row[key].edit;
                    }
                    else {
                        url = '';
                    }
                }
            }
            if (row.type.id == 3) {
                url = url + 'cms_content/';
            }
            if (row.type.id == 4) {
                url = url + 'clips/';
            }
            if (url !== '') {
                if (!data || (data && data == '')) {
                    data = 'NOT PROVIDED';
                }
                return '<a href="' + url + '" title="' + data + '">' + data + '</a>';
            }
        }
        return data;
    };
    // this requires the row to contain an "edit" link
    DataTablesRenderers.edit = function (data, type, row, meta) {
        if (type === 'display') {
            var url = typeof row.edit !== 'undefined' && row.edit ? row.edit : '';
            if (meta.settings.aoColumns.length > meta.col) {
                var pieces = meta.settings.aoColumns[meta.col].mData.split('.');
                var key = pieces[0];
                if (pieces.length > 1 && typeof row[key] !== 'undefined' && row[key] !== null && typeof row[key].edit !== 'undefined') {
                    if (row[key].edit) {
                        url = row[key].edit;
                    }
                    else {
                        url = '';
                    }
                }
            }
            if (url !== '') {
                if (!data || (data && data == '')) {
                    data = 'NOT PROVIDED';
                }
                return '<a href="' + url + '" title="' + data + '">' + data + '</a>';
            }
        }
        return data;
    };
    DataTablesRenderers.action = function (data, type, row, meta) {
        var display = ["<div class=\"btn-group btn-group-sm\" role=\"group\">"];
        if (type === 'display') {
            // this requires the row to contain a "delete" link
            if (typeof row.delete != 'undefined' && row.delete && row.delete != '') {
                display.push('<a href="' + row.delete + '" title="Delete" target="_blank" class="dt-delete-row btn btn-outline-danger py-1"><i class="fa-regular fa-trash-can"></i></a>');
            }
            // this requires the row to contain a "impersonate" link
            if (typeof row.impersonate != 'undefined' && row.impersonate && row.impersonate != '') {
                display.push('<a href="' + row.impersonate + '" title="Impersonate" class="dt-impersonate-row btn btn-outline-primary py-1"><i class="fad fa-theater-masks"></i></a>');
            }
            display.push("</div>");
        }
        return display.join('');
    };
    DataTablesRenderers.datetime = function (data, type, row, meta) {
        if (type === 'display' && data) {
            var d = new Date(data);
            var f = new Intl.DateTimeFormat("en", {
                timeZone: CURRENT_TIMEZONE,
                year: '2-digit',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                timeZoneName: "short"
            });
            return f.format(d);
        }
        return data;
    };
    DataTablesRenderers.user = function (data, type, row, meta) {
        if (type == 'display' && data != null) {
            var display_name = [];
            if (data.first_name) {
                display_name.push(data.first_name);
            }
            if (data.last_name) {
                display_name.push(data.last_name);
            }
            return display_name.join(" ");
        }
        return "";
    };
})(DataTablesRenderers || (DataTablesRenderers = {}));
var DataTablesHelpers;
(function (DataTablesHelpers) {
    // export const defaults = DataTablesDefaults
    DataTablesHelpers.renderers = DataTablesRenderers;
})(DataTablesHelpers || (DataTablesHelpers = {}));
window.datatables_helpers = DataTablesHelpers;
